module.exports = {
  credentialStatusUpdate: 'Failed to update credential status',
  credentialUpdate: 'Failed to update credential',
  credentialCreate: 'Failed to create credential',
  credentialInsecureMessage: 'The credentials are stored without certificate. This is not secure.',
  skillRemoveFailed: 'Failed to remove skill',
  skillResourceNotFound: 'Could not locate the underlying static resource',
  skillAttachFailed: 'Failed to attach skill',
  cronStatusUpdate: 'Failed to update cron status',
  cronUpdate: 'Failed to update cron',
  agentUpdate: 'Failed to update agent',
  agentCreate: 'Failed to create agent',
  agentStatusUpdate: 'Failed to update agent status',
  cronCreate: 'Failed to create cron',
  restStatusUpdate: 'Failed to update rest status',
  restUpdate: 'Failed to update rest',
  restCreate: 'Failed to create rest',
  dateWrong: 'Date From cannot be after date to',
  dateFromEmpty: 'From Date must not be empty',
  dateTillEmpty: 'To Date must not be empty',
  processStatusUpdate: 'Failed to update process status',
  processUpdate: 'Failed to update process',
  processCreate: 'Failed to create process',
  processRequired: 'Process is required',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  somethingWentWrong: 'Something went wrong! :(',
  maybeLinkWasExpired: 'Maybe your link expired',
  userStatusUpdate: 'Failed to update user status',
  userUpdate: 'Failed to update user',
  userCreate: 'Failed to create user',
  roleUpdate: 'Failed to update role',
  roleCreate: 'Failed to create role',
  tagUpdate: 'Failed to update tag',
  tagCreate: 'Failed to create tag',
  test: 'Test Unsuccessful',
  templateUpdate: 'Failed to update template',
  templateCreate: 'Failed to create template',
  translationUpdate: 'Failed to update translation',
  translationCreate: 'Failed to create translation',
  translationDelete: 'Failed to delete translation',
  resendPassword: 'Failed to send password reset instructions',
  settingStatusUpdate: 'Failed to update setting status',
  settingUpdate: 'Failed to update setting',
  settingCreate: 'Failed to create setting',
  staticResourceUpdate: 'Failed to update static resource',
  staticResourceCreate: 'Failed to create static resource',
  staticResourceStatusUpdate: 'Failed to update static resource status',
  staticResourceUpload: 'Failed to upload static resource',
  staticResourceDownoad: 'Failed to download static resource',
  staticResourceView: 'Could not load',
  zeroSteps: 'Please add at least one step in order to be able to save a process',
  noPaste: 'No step item in memory',
  wrongPaste: 'Item in memory is of the wrong type',
  tokenMissing: 'Token Missing',
  passwordNotSame: 'Passwords do not match',
  formatEmail: 'Not valid Email format',
  invalidUrl: 'Invalid URL',
  mustBeNumber: 'Must be a number',
  required: 'Required',
  cronExecute: 'Cron execute error',
  check: 'Check Error',
  checkIsExists: 'Combination of Method and Url already exists with trigger ID:',
  duplicatedKeys: 'Duplicated key detected',
  moduleUpdate: 'Failed to update module',
  moduleCreate: 'Failed to create module',
  readOnly: 'You are accessing this resource in read only mode',
  editRoleCreate: 'Resource should have at least one Edit Role assigned',
  moduleExport: 'Failed to export module',
  moduleImport: 'Failed to import module',
  moduleValidate: 'Failed to validate module',
  moduleTooBig: 'Your import is currently taking longer than usual due to the size of the data. The process is still ongoing and is expected to complete successfully. Please check back later to confirm its status.',
  noFeSettings: 'No active frontend settings found',
  multipleFeSettings: 'Multiple frontend settings found, please fix configuration',
  ttlToBig: 'TTL is more than 10 years into the future',
  validationUpdate: 'Failed to update validation rule',
  validationCreate: 'Failed to create validation rule',
  noLogs: 'No step logs found for Event ID',
  variableJavaWrong: 'Name is not by Variable Naming Convention',
  valueNotAllowed: 'Value Not Allowed',
  apiKeyGeneration: 'Error generating ApiKey',
  moduleUpload: 'Failed to upload module',
  moduleDownload: 'Failed to download module',
  moduleInstall: 'Failed to install module',
  pluginStatusUpdate: 'Failed to update plugin status',
  pluginUpdate: 'Failed to update plugin',
  pluginCreate: 'Failed to create plugin',
  pluginDelete: 'Failed to delete plugin',
  pluginImport: 'Failed to import plugin',
  nameInUse: 'Process name already in use',
  noCache: 'No cache for this step log',
  duplicatedVars: 'Duplicated variable detected',
  execute: 'Script execution Unsuccessful',
  chatExecute: 'Chat execution failed',
  chatLoad: 'Failed to load chats',
  chatHistoryLoad: 'Failed to load chat history',
  multipleCredentials: 'Multiple matching credentials found!',
  noEvents: 'No events available',
  triggerRestUrlValidation: 'The following field(s) are not defined in the path variable rule',
  triggerRestPathVarValidation: 'The following field(s) are defined in the path variable rule, but not in the URL',
  restPathValidation: 'The path must start with "/" ',
  mustBeTwoLong: 'Must be two characters',
  errorSwagger: 'Error downloading Swagger',
  multipleSettings: 'Multiple matching settings found!',
  wrongSearchParam: 'Incorrect value',
  slackMessage: 'Message too long',
  pdfGenerate: 'PDF generation error',
  latexGenerate: 'LaTeX generation error',
  htmlGenerate: 'HTML generation error',
  mustLessExecutions: 'Simultaneous executions per instance must be less than or equal to overall simultaneous executions',
  nothingToCopy: 'Nothing to copy',
  missingEmail: 'Please enter your email.',
  missingCaptcha: 'Please enter the captcha.',
  messagingStatusUpdate: 'Failed to update messaging status',
  messagingUpdate: 'Failed to update messaging',
  messagingCreate: 'Failed to create messaging',
  selectServiceFirst: 'Please select a service first',
  libraryStatusUpdate: 'Failed to update library status',
  libraryUpdate: 'Failed to update library',
  libraryCreate: 'Failed to create library',
  libraryUpload: 'Failed to upload library',
  passwordLength: 'Password must be at least 6 characters long',
  passwordsMatch: 'Old and new passwords must be different',
  passwordsDontMatch: 'Passwords do not match',
  profileSaveFailed: 'Failed to save preferences. Your changes are saved locally.',
  storageUpdate: 'Failed to update storage',
  storageCreate: 'Failed to create storage',
  credentialVariableName: 'Credentials using variable names are assigned at runtime.',
  eventHandlerStatusUpdate: 'Failed to update event handler status',
  eventHandlerUpdate: 'Failed to update event handler',
  eventHandlerCreate: 'Failed to create event handler',
  listenProcessSame: 'Listen process cannot be the same as the process being listened to',
  entityStatusUpdate: 'Failed to update entity status',
  entityUpdate: 'Failed to update entity',
  entityCreate: 'Failed to create entity',
  entityValidation: 'Failed to validate entity',
  entityGenerate: 'Failed to generate entity',
  entityNameCantStartWithNumber: 'Entity name cannot start with a number',
  entityFieldNamesCantStartWithNumber: 'Field names cannot start with a number',
  entityWithThisNameExists: 'Entity with this name already exists',
  onePrimaryKey: 'Entity must have one primary key',
  historyFetch: 'Failed to fetch history',
  fieldCantHaveIdName: 'Field Name cannot be "_id" as this is a reserved name for the system',
  nameTooShortOrLong: 'Name must be between 2 and 250 characters long',
  nameTooShortOrLong64: 'Name must be between 2 and 64 characters long',
  restBasic: 'Both username and password are required for basic authentication',
  restBearer: 'Bearer token is required for bearer authentication',
  noPermission: 'You do not have permission for this or connected resources',
  cannotUseVariableFormat: 'Cannot use variable format',
  urlStartsWithSystem: 'URL cannot start with /system',
  urlStartsWithMcp: 'URL cannot start with /mcp',
  urlMustStartWithSlash: 'URL must start with /',
  credentialCorruptedMessage: 'Required fields are missing in the credential. Please enter the necessary values.',
  unauthorized: 'You do not have permission to access this resource.',
  noShadowObject: 'Shadow objects not found for the selected entity.',
  dataEmpty: 'Empty data returned',
  noDataAvailable: 'No data available',
  notFound: 'Resource not Found',
  invalidJson: 'Invalid JSON value in field: ',
  moduleDescription: 'Description field cannot be empty or contain only spaces. Please enter a valid description.',
  moduleName: 'Name field cannot be empty or contain only spaces. Please enter a valid name.',
  entityMustContainNonPrimaryField: 'A primary key field cannot be the only field defined; please add at least one more field.',
  entityCantBeDeleted: 'Entity can not be deleted, as it is referenced by others',
  listOfUsedEntities: 'The entity you are trying to delete is used in the following entities:',
  invalidJsonFields: 'Invalid JSON in fields:',
  fillRequiredFields: 'Fill in required fields!',
  fieldEditedSuccessfully: 'Field edited successfully',
  fieldCreatedSuccessfully: 'Field created successfully',
  errorParsingJsonFields: 'Error parsing JSON field',
  max30Chars: 'Max 30 characters',
  onlyLettersNumbersUnderscore: 'Only letters, numbers and underscore are allowed',
  systemPrefixNotAllowed: 'Index names starting with "system_" are not allowed',
  reservedPage: 'The name page is reserved for internal usage, please use a different name',
  reservedSize: 'The name size is reserved for internal usage, please use a different name',
  invalidJsonInFields: 'Invalid JSON in fields',
  interruptEventsError: 'Failed to interrupt events',
  wrongAuthCombination: 'Wrong authentication combination',
  tooShortOrLong64: 'Must be between 1 and 64',
  logsTimeLessThanMax: 'Logs TTL and Error Logs TTL must be higher than Max Execution Time',
  max10years: 'TTL is more than 10 years into the future',
  between1Msecand7day: 'Duration must be between 1 millisecond and 7 days',
  nameTooShort: 'Name must be at least 2 characters long',
  notAllRequiredInputVariablesSet: 'Not all required input variables are set',
  noSettingsFound: 'No settings found',
  duplicatedPathVariables: 'Duplicated path variables in the URL',
  mixedPathVariables: 'Mixed path variables or non-variable content in the same segment in the URL',
  noQueryParametersInRestUUrl: 'No query parameters allowed in REST URL. Please use corresponding validations.',
  urlValidation: 'The path must either be a variable or contain only letters,numbers,hyphens and underscores',
  mustBeGreaterThanZero: 'Must be greater than zero',
  invalidPasswordSpaces: 'Password must not be empty ',
  invalidTimestamp: 'Invalid timestamp format! Example: 2021-01-01 00:00:00',
  booleanCannotBePrimaryKey: 'Boolean fields cannot be set to primary key',
  noSpaces: 'Content field cannot be blank.',
  possibleQrSizes: 'The value must be between 100 and 3500.',
  cannotDeleteDueToRelation: 'Cannot delete due to relation with another entity',
  noRestoreResource: 'No resource found to restore',
  fieldDeletedSuccessfully: 'Field deleted successfully',
  numericOnly: 'Only numeric values are allowed',
  otpLength: 'OTP must be 6 characters long',
  noUsagesFound: 'No usages found',
  svgNotAllowedForFonts: 'SVG files are not allowed for font resources.',
  flushFailed: 'Cache flush failed',
  mustBePositive: 'Must be a positive number',
  templateBodyBlank: 'Template Body must not be blank',
  retryAfterMsMinMax: 'Retry after MS must be between 100 and 15000',
  retryAttemptsMinMax: 'Retry attempts must be between 1 and 15',
  stdoutStderrRange: 'Value must be between 1000 and 32000',
  multipleValidations: 'Multiple matching validations found!',
  validationVariableName: 'Validation name is a variable; cannot open.',
  unauthenticated: 'You are not logged in or your session has expired. Please log in again to continue.',
  badGateway: 'Bad Gateway',
  serviceUnavailable: 'Service Unavailable',
  gatewayTimeout: 'Gateway Timeout',
  timeout: 'Request timed out. Try again.',
  conflict: 'Conflict detected. Please refresh.',
  validation: 'Validation error. Check your inputs.',
  locked: 'Resource is locked. Try again later.',
  rateLimited: 'Too many requests. Please slow down.',
  mcpUpdate: 'Failed to update MCP',
  mcpCreate: 'Failed to create MCP',
  mcpStatusUpdate: 'Failed to update MCP status',
  mustBeUnique: 'Tool name must be unique',
  duplicateToolNames: 'Duplicate tool names found:',
  pollingIntervalMsMin: 'Polling interval MS must be minimum 100',
  timeoutMsMin: 'Timeout MS must be minimum 1000',
  valueMinMax: 'Min value must be between 1 and 1000',
  minValue: 'Minimum value is 1',
  cantBeExported: 'This module cannot be exported',
  multipleCredentialsPrecise: 'Multiple credentials with the same name were found.',
  multipleTemplatesPrecise: 'Multiple templates with the same name were found.',
  multiplePluginSettingsPrecise: 'Multiple plugin settings with the same name were found.',
  multiplePluginsPrecise: 'Multiple plugins with the same name were found.',
  credentialNotFound: 'The selected credential was not found, please select an existing credential.',
  applicationNotFound: 'The selected application was not found, please select an existing application.',
  templateNotFound: 'The selected template was not found, please select an existing template.',
  nameTooShortOrLong120: 'Name must be between 2 and 120 characters long',
  mongoSystemPrefixForbidden: 'System prefix is forbidden for MongoDB entities',
  screenStatusUpdate: 'Failed to update screen status',
  screenUpdate: 'Failed to update screen',
  screenCreate: 'Failed to create screen',
  failedToLoadTenants: 'Failed to load tenants',
  tenantStatusUpdate: 'Failed to update tenant status',
  tenantUpdate: 'Failed to update tenant',
  tenantCreate: 'Failed to create tenant',
  uiTriggerStatusUpdate: 'Failed to update UI Trigger status',
  uiTriggerUpdate: 'Failed to update UI Trigger',
  uiTriggerCreate: 'Failed to create UI Trigger',
  uiTriggerDelete: 'Failed to delete UI Trigger',
  screensFetch: 'Failed to fetch screens',
  flowStatusUpdate: 'Failed to update flow status',
  flowFetch: 'Failed to fetch flows',
  flowUpdate: 'Failed to update flow',
  flowCreate: 'Failed to create flow',
  flowDelete: 'Failed to delete flow',
  tenantUserCreate: 'Failed to create tenant user',
  tenantUserStatusUpdate: 'Failed to update tenant user status',
  tenantUsersFetch: 'Failed to fetch tenant users',
  languageLoadTimeout: 'Language load timed out. Please check your connection and try again.',
  languageLoadFailed: 'Failed to load language. Keeping current language.',
  invalidUuid: 'Invalid UUID format. Expected format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
  whatsappCreate: 'Failed to create WhatsApp trigger',
  whatsappUpdate: 'Failed to update WhatsApp trigger',
  whatsappDelete: 'Failed to delete WhatsApp trigger',
  whatsappStatusUpdate: 'Failed to update WhatsApp trigger status',
  whatsappCredentialRequired: 'Please select a WhatsApp credential',
  webhookPathTooLong: 'Webhook path must not exceed 300 characters',
  webhookPathInvalidChars: 'Webhook path can only contain letters, numbers, hyphens, underscores, and forward slashes',
  webhookPathDoubleSlash: 'Webhook path cannot contain double slashes',
  webhookPathTrailingSlash: 'Webhook path cannot end with a slash',
  priorityRange: 'Priority must be between 1 and 128',
  maxInstances: 'Maximum 48 instances allowed',
  errorLoadingColumns: 'Error loading columns',
  errorLoadingData: 'Error loading data',
  errorLoadingIndexes: 'Error loading indexes',
  errorLoadingSequences: 'Error loading sequences',
  applicationStatusUpdate: 'Failed to update application status',
  applicationUpdate: 'Failed to update application',
  applicationCreate: 'Failed to create application',
  atLeastOneTagRequired: 'At least one tag is required',
  tokenOrPrivateKeyRequired: 'At least one of Token or Private Key is required',
  gitFieldsAllRequired: 'All git fields are required when any git field is provided',
  temperatureRange: 'Temperature must be between 0 and 2',
  temperatureRangeClaude: 'Temperature must be between 0 and 1',
  fileUpload: 'Failed to upload file. Please try again.',
  fileDownload: 'Failed to download file. Please try again.',
  fileView: 'Failed to open file for viewing. Please try again.',
  fileDelete: 'Failed to delete file. Please try again.',
  reservedDollarDotPrefix: 'Name cannot start with "$." \u2014 this prefix is reserved for variables.',
  gitOperationFailed: 'Git operation failed \u2014 see output panel for details',
  gitPullFailed: 'Pull failed',
  gitPushFailed: 'Push failed',
  gitCloneFailed: 'Clone failed',
  gitCheckoutFailed: 'Branch checkout failed',
  gitStageAllFailed: 'Stage all failed',
  gitCommitFailed: 'Commit failed',
  gitInitialFetchFailed: 'Could not load Git state. Press Refresh to retry.',
  gitStagePathFailed: 'Failed to stage path',
  gitUnstagePathFailed: 'Failed to unstage path',
  gitDiffFailed: 'Failed to load diff',
  refreshSkillsFailed: 'Failed to refresh credentials. Please try again.',
  deploymentCredentialRequired: 'Deployment credential required',
  buildPathRequired: 'Build path required',
  buildCommandListRequired: 'Build command list required',
  uploadTriggerFailed: 'Upload trigger failed',
  uploadStatusCheckFailed: 'Status check failed'
}
